module.exports = __webpack_public_path__ + "static/media/chevron-down.b79f7d72.svg";